export enum LoggingLevels {
  error = 0,
  warning = 1,
  info = 2,
  debug = 3,
}

type TypeLoggingLevelsToConsoleLevel = { [key in LoggingLevels]: (arg: any) => void };

export const LoggingLevelsToConsoleMethod: TypeLoggingLevelsToConsoleLevel = {
  [LoggingLevels.error]: console.error,
  [LoggingLevels.warning]: console.warn,
  [LoggingLevels.info]: console.info,
  [LoggingLevels.debug]: console.debug,
};
